import Cookies from 'universal-cookie';
import { SHOW_QUESTIONNAIRE_COOKIE } from '@fiverr-private/user_questionnaire';

export const setShowQuestionnaireCookie = () => {
    const cookies = new Cookies();
    cookies.set(SHOW_QUESTIONNAIRE_COOKIE, 'true', {
        secure: true,
        sameSite: 'lax',
        maxAge: 10080,
        path: '/',
    });
};
